module.exports = __webpack_public_path__ + "img/Logo_GE_2.5b55e279.png";